<template>
  <div class="row mt-5">
    <h3 class="title-page">AIRWALLEX TRANSFERS</h3>
    <div class="col-12 mt-3">
      <div class="card-custom">
        <div class="table-responsive p-0 custom-table table-stack-host">
          <table class="table align-items-center mb-0 table-stack-mobile">
            <thead>
              <tr>
                <th class="text-center font-weight-bolder">{{ $t("airwallexBalance.colCreatedAt") }}</th>
                <th class="text-center font-weight-bolder">{{ $t("airwallexBalance.colTransferId") }}</th>
                <th class="text-center font-weight-bolder">{{ $t("airwallexBalance.colAccountId") }}</th>
                <th class="text-center font-weight-bolder">{{ $t("airwallexBalance.colBeneficiary") }}</th>
                <th class="text-center font-weight-bolder">{{ $t("airwallexBalance.colAmount") }}</th>
                <th class="text-center font-weight-bolder">{{ $t("airwallexBalance.colReference") }}</th>
                <th class="text-center font-weight-bolder">{{ $t("airwallexBalance.colTransferStatus") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!transfers.length">
                <td colspan="7" class="text-center text-xss text-muted py-4">
                  No transfers yet
                </td>
              </tr>
              <tr v-for="transfer in transfers" :key="transfer.id">
                <td class="text-center text-xss" :data-label="$t('airwallexBalance.colCreatedAt')">{{ formatDate(transfer.created_at) }}</td>
                <td class="text-center text-xss" :data-label="$t('airwallexBalance.colTransferId')">{{ transfer.transfer_id || '-' }}</td>
                <td class="text-center text-xss" :data-label="$t('airwallexBalance.colAccountId')">{{ transfer.connected_account_id }}</td>
                <td class="text-center text-xss" :data-label="$t('airwallexBalance.colBeneficiary')">
                  <div>{{ transfer.beneficiary_name || '-' }}</div>
                  <small v-if="transfer.beneficiary_identifier" class="text-muted">
                    {{ transfer.beneficiary_identifier }}
                  </small>
                </td>
                <td class="text-center text-xss" :data-label="$t('airwallexBalance.colAmount')">
                  {{ formatPrice(transfer.transfer_amount) }}
                </td>
                <td class="text-center text-xss" :data-label="$t('airwallexBalance.colReference')">{{ transfer.reference || '-' }}</td>
                <td class="text-center text-xss" :data-label="$t('airwallexBalance.colTransferStatus')">
                  <span class="badge" :class="statusBadgeClass(transfer.status)">
                    {{ transfer.status || 'PENDING' }}
                  </span>
                  <div v-if="transfer.error_message" class="text-danger small mt-1">
                    {{ transfer.error_message }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          v-if="pagination.last_page > 1"
          :pagination="pagination"
          :current_page="pagination.current_page"
          :last_page="pagination.last_page"
          pageTitle="airwallexTransfers"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaymentService from "../../../services/payment.service";
import Pagination from "@/components/Pagination.vue";
import { formatPrice } from "@/config/utils";

const SUCCESS_STATUSES = ["PAID", "SENT", "FUNDED", "FUNDING.FUNDED"];
const PROGRESS_STATUSES = [
  "IN_APPROVAL",
  "SCHEDULED",
  "FUNDING.SCHEDULED",
  "FUNDING.PROCESSING",
  "FUNDING.REQUIRES_FUNDING_CONFIRMATION",
  "PROCESSING",
];
const FAILED_STATUSES = [
  "FAILED",
  "FUNDING.FAILED",
  "APPROVAL_REJECTED",
  "APPROVAL_BLOCKED",
];

export default {
  name: "airwallex-transfer-list",
  components: { Pagination },
  data() {
    return {
      transfers: [],
      pagination: {},
      page: 1,
      loading: false,
    };
  },
  mounted() {
    this.getList(1);
  },
  methods: {
    getList(page = 1, pageTitle = null) {
      // Pagination component passes `pageTitle` so a parent hosting multiple
      // lists can route; we accept and ignore it for self-hosting use.
      if (pageTitle && pageTitle !== "airwallexTransfers") return;

      this.loading = true;
      PaymentService.airwallexListTransfers({
        page,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data || {};
            this.transfers = data.data || [];
            this.pagination = data;
            this.page = data.current_page || 1;
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    },

    formatDate(dt) {
      if (!dt) return "";
      const d = new Date(dt);
      if (isNaN(d.getTime())) return dt;
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    formatPrice,

    statusBadgeClass(status) {
      if (!status) return "bg-secondary";
      if (SUCCESS_STATUSES.includes(status)) return "bg-success";
      if (FAILED_STATUSES.includes(status) || status.includes("CANCELLED") || status.includes("REVERSED")) return "bg-danger";
      if (PROGRESS_STATUSES.includes(status)) return "bg-info";
      return "bg-secondary";
    },
  },
};
</script>

<style scoped>
.bg-success {
  background: #198754 !important;
  color: #fff !important;
}
.bg-info {
  background: #0dcaf0 !important;
  color: #000 !important;
}
.bg-danger {
  background: #dc3545 !important;
  color: #fff !important;
}
.bg-secondary {
  background: #6c757d !important;
  color: #fff !important;
}
</style>
